<template>
  <div :class="{ 'messages-drawer': true, 'is-open': isOpen }">
    <div class="drawer-overlay" @click="close"></div>

    <div class="drawer-content bg-white shadow-lg">
      <div class="drawer-header p-3 border-bottom d-flex justify-content-between align-items-center">
        <h5 class="mb-0">{{ $t('systemMessages.systemMessages') }}</h5>

        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="danger"
        class="m-3 text-center">
        {{ $t('systemMessages.failedToLoad') }}
        <br>
        <d-button
          theme="light"
          size="sm"
          class="mt-2"
          @click="fetchMessages(true)">
          <i class="material-icons mr-1" style="font-size: 14px;">refresh</i>
          {{ $t('ui.tryAgain') }}
        </d-button>
      </d-alert>
      <div
        v-else-if="isLoading"
        class="d-block position-relative py-4"
        style="min-height: 50px;">
        <div  class="pb-3 pt-3 text-center overlay-loading">
          {{ $t('ui.dataLoading') }}&hellip;
        </div>
      </div>
      <div
        v-else
        class="drawer-body pt-3">
        <d-tabs>
          <d-tab title="Nieprzeczytane" active>
            <div class="messages-list">
              <div
                v-if="!unreadSystemMessages.length && !isLoading"
                class="p-4 text-center text-muted">
                {{ $t('systemMessages.noNewMessages') }}
              </div>
              <system-message-item
                v-for="unread in unreadSystemMessages"
                :key="'unread-messages-' + unread.id"
                :message="unread"
                @refresh="handleRefresh" />
            </div>
          </d-tab>

          <d-tab title="Wszystkie">
            <div class="messages-list">
              <div
                v-if="!allSystemMessages.length && !isLoading"
                class="p-4 text-center text-muted">
                {{ $t('systemMessages.noMessages') }}
              </div>

              <system-message-item
                v-for="message in allSystemMessages"
                :key="'all-messages-' + message.id"
                :message="message"
                @refresh="handleRefresh" />

              <div
                v-if="hasMore && allSystemMessages.length > 0"
                class="text-center p-3">
                <d-button
                  class="ml-auto"
                  theme="primary"
                  variant="outlined"
                  :disabled="isLoading"
                  @click="loadMore">
                  <div
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm"
                    role="status"></div>
                  <i
                    v-else
                    class="material-icons">
                    cached
                  </i>
                </d-button>
              </div>
            </div>
          </d-tab>
        </d-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import SystemMessageItem from './SystemMessageItem.vue';

export default {
  name: 'system-messages-drawer',
  components: {
    SystemMessageItem
  },
  data() {
    return {
      isOpen: false,
      messages: [],
      isLoading: false,
      loadError: false,
      page: 1,
      hasMore: true
    };
  },
  computed: {
    unreadSystemMessages() {
      return this.messages.filter(msg => !msg.read_at);
    },
    allSystemMessages() {
      return this.messages;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.fetchMessages(true);
      }
    }
  },
  created() {
    this.$bus.$on('system-messages-drawer-toggle', (state) => {
      this.isOpen = (state !== undefined) ? state : !this.isOpen;
    });
  },
  methods: {
    close () {
      this.isOpen = false;
    },
    handleRefresh () {
      this.fetchMessages(true);
      this.$bus.$emit('system-messages-refresh-trigger');
    },
    fetchMessages (reset = false) {
      if (reset) {
        this.page = 1;
        this.hasMore = true;
      }

      if (!this.hasMore) {
        return;
      }

      this.isLoading = true;
      this.loadError = false;

      this.$http.get('/messages/items-for-user', {
        params: { page: this.page }
      })
        .then(response => {
          const newMessages = response.data.data || response.data || [];

          if (reset) {
            this.messages = newMessages;
          } else {
            this.messages = [...this.messages, ...newMessages];
          }

          const lastPage = response.data.meta ? response.data.meta.last_page : (response.data.last_page || 1);

          if (this.page >= lastPage || newMessages.length === 0) {
            this.hasMore = false;
          }
        })
        .catch(error => {
          console.error('Błąd pobierania komunikatów systemowych:', error);
          this.loadError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadMore () {
      this.page++;
      this.fetchMessages(false);
    }
  }
}
</script>

<style lang="scss" scoped>
.messages-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  visibility: hidden;
  transition: all 0.3s;

  &.is-open {
    visibility: visible;
    .drawer-overlay { opacity: 1; }
    .drawer-content { transform: translateX(0); }
  }

  .drawer-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    opacity: 0;
    transition: opacity 0.3s;
  }

  .drawer-content {
    position: absolute;
    right: 0;
    width: 400px;
    height: 100%;
    transform: translateX(100%);
    transition: transform 0.3s;
    display: flex;
    flex-direction: column;
  }

  .drawer-body {
    flex: 1;
    overflow-y: auto;
  }

  .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto;
  }
}
</style>
